import { SelectField } from "@edgetier/select";
import { FunctionComponent, memo } from "react";
import { IProps } from "./select-model.types";
import { useModels } from "hooks-for/models/use-models";
import "./select-model.scss";

/**
 * Request models and display them in a select field.
 * @param props.name       The name of the select field.
 * @param props.otherProps Props that can be applied to the select field.
 * @returns                Model select.
 */
const SelectModel: FunctionComponent<IProps> = ({ name = "modelId", queryParameters, ...otherProps }) => {
    const { data: models, isLoading } = useModels(queryParameters);

    return (
        <SelectField
            description="model"
            getLabel={({ model }) => model ?? ""}
            getValue={({ modelId }) => modelId}
            isLoading={isLoading}
            items={models || []}
            name={name}
            {...otherProps}
        />
    );
};

export default memo(SelectModel);
